import React, { useEffect } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import MediaQuery from 'react-responsive';
import CSSModules from 'react-css-modules';
import { browserHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import { actions as contextActions } from '../../redux/context';
import { actions as joinedPrograms } from '../../redux/programs/joinedPrograms';

import {
  targetUserSelector,
  targetUserIdSelector,
} from '../../redux/context/selectors';
import {
  joinedProgramsListSelector,
  joinedProgramsMetaSelector,
  joinedProgramsSendingSelector,
} from '../../redux/programs/selectors';
import { MESSAGES } from '../../constants/routes';
import { BREAKPOINT } from '../../constants/styles';
import { CHAT, PROGRAMS_TITLE } from '../../constants/strings';
import { useProgramTabs } from './hooks';
import BackButton from '../common/BackButton';
import MobileNavbar from '../common/MobileNavbar';
import { CommonTabs } from '../common/CommonTabs';
import { selectDeepLinkTab } from '../../redux/healthboard/patientPortal/selectors';

import styles from './index.styl';
import { usePageView } from '../../hocs/usePageView';
import MetaHelmet from '../AppHelmet/MetaHelmet';

function MobileNavigation({ title, isHandleBack }) {
  return (
    <MediaQuery maxWidth={BREAKPOINT}>
      <MobileNavbar openContext="arrow-down" toggleContext={isHandleBack}>
        <p children={title} />
      </MobileNavbar>
    </MediaQuery>
  );
}

MobileNavigation.propTypes = {
  title: PropTypes.string,
  isHandleBack: PropTypes.func,
};

function Programs({ routes, params: { id }, intl: { formatMessage } }) {
  const dispatch = useDispatch();

  const profileData = useSelector(targetUserSelector);
  const targetUserId = useSelector(targetUserIdSelector);
  const programs = useSelector(joinedProgramsListSelector);
  const counters = useSelector(joinedProgramsMetaSelector);
  const sending = useSelector(joinedProgramsSendingSelector);
  const deepLinkProgramTab = useSelector(selectDeepLinkTab);

  const user = profileData.displayableName;

  const tabs = useProgramTabs({
    user,
    sending,
    programs,
    counters,
    formatMessage,
    deepLinkProgramTab,
  });

  usePageView('Programs');

  useEffect(() => {
    if (Number(id) !== targetUserId)
      dispatch(contextActions.setTargetUserId({ id }));
  }, []);

  useEffect(() => {
    dispatch(joinedPrograms.send({ id, filterBy: tabs.active }));
  }, [id, tabs.active]);

  const handleBack = () => {
    browserHistory.push(`/${MESSAGES}`);
  };

  const isProfile = get(routes, '[1].path') === 'profile';
  const rootClassName = !isProfile ? 'g-content' : '';

  return (
    <div className={rootClassName} styleName="root">
      <MetaHelmet title="pages.title.programs" />

      <If condition={!isProfile}>
        <MediaQuery maxWidth={BREAKPOINT}>
          <MobileNavigation
            isHandleBack={handleBack}
            title={formatMessage(PROGRAMS_TITLE)}
          />
        </MediaQuery>

        <div styleName="header">
          <MediaQuery minWidth={BREAKPOINT}>
            <BackButton onBack={handleBack} />
          </MediaQuery>
        </div>
      </If>

      <div styleName="content">
        <div styleName="content-header">
          <div>
            <div styleName="program-title">{formatMessage(PROGRAMS_TITLE)}</div>
            <div styleName="program-context">
              {' '}
              {formatMessage(CHAT.inContextOf)} {user}
            </div>
          </div>
        </div>

        <div styleName="program-container">
          <CommonTabs
            tabList={tabs.list}
            activeTab={tabs.active}
            renderContent={tabs.render}
            onTabSelect={tabs.setActive}
          />
        </div>
      </div>
    </div>
  );
}

Programs.propTypes = {
  intl: PropTypes.object,
  routes: PropTypes.array,
  params: PropTypes.object,
};

export default compose(
  injectIntl,
  CSSModules(styles, { allowMultiple: true }),
)(Programs);



// WEBPACK FOOTER //
// ./src/components/Programs/index.jsx